{
  "asyncapi": "3.1.0",
  "info": {
    "title": "Springwolf example project - JMS",
    "version": "1.0.0",
    "description": "Springwolf [example project](https://github.com/springwolf/springwolf-core/tree/main/springwolf-examples/springwolf-jms-example) to demonstrate springwolfs abilities, including **markdown** support for descriptions.",
    "termsOfService": "https://asyncapi.org/terms",
    "contact": {
      "name": "springwolf",
      "url": "https://github.com/springwolf/springwolf-core",
      "email": "example@example.com"
    },
    "license": {
      "name": "Apache License 2.0"
    },
    "x-generator": "springwolf"
  },
  "defaultContentType": "application/json",
  "servers": {
    "jms-server": {
      "host": "tcp://activemq:61616",
      "protocol": "jms"
    }
  },
  "channels": {
    "another-queue": {
      "address": "another-queue",
      "messages": {
        "io.github.springwolf.examples.jms.dtos.AnotherPayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.jms.dtos.AnotherPayloadDto"
        }
      },
      "bindings": {
        "jms": {
          "bindingVersion": "0.0.1"
        }
      }
    },
    "example-queue": {
      "address": "example-queue",
      "messages": {
        "io.github.springwolf.examples.jms.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.jms.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "jms": {
          "bindingVersion": "0.0.1"
        }
      }
    }
  },
  "components": {
    "schemas": {
      "HeadersNotDocumented": {
        "title": "HeadersNotDocumented",
        "type": "object",
        "properties": { },
        "description": "There can be headers, but they are not explicitly documented.",
        "examples": [
          { }
        ]
      },
      "io.github.springwolf.examples.jms.dtos.AnotherPayloadDto": {
        "title": "AnotherPayloadDto",
        "type": "object",
        "properties": {
          "example": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.jms.dtos.ExamplePayloadDto"
          },
          "foo": {
            "type": "string",
            "description": "Foo field",
            "maxLength": 100,
            "examples": [
              "bar"
            ]
          }
        },
        "description": "Another payload model",
        "examples": [
          {
            "example": {
              "someEnum": "FOO2",
              "someLong": 5,
              "someString": "some string value"
            },
            "foo": "bar"
          }
        ],
        "required": [
          "example"
        ]
      },
      "io.github.springwolf.examples.jms.dtos.ExamplePayloadDto": {
        "title": "ExamplePayloadDto",
        "type": "object",
        "properties": {
          "someEnum": {
            "title": "ExampleEnum",
            "type": "string",
            "description": "Some enum field",
            "enum": [
              "FOO1",
              "FOO2",
              "FOO3"
            ],
            "examples": [
              "FOO2"
            ]
          },
          "someLong": {
            "type": "integer",
            "description": "Some long field",
            "format": "int64",
            "minimum": 0,
            "examples": [
              5
            ]
          },
          "someString": {
            "type": "string",
            "description": "Some string field",
            "examples": [
              "some string value"
            ]
          }
        },
        "description": "Example payload model",
        "examples": [
          {
            "someEnum": "FOO2",
            "someLong": 5,
            "someString": "some string value"
          }
        ],
        "required": [
          "someEnum",
          "someString"
        ]
      }
    },
    "messages": {
      "io.github.springwolf.examples.jms.dtos.AnotherPayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.jms.dtos.AnotherPayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.jms.dtos.AnotherPayloadDto",
        "title": "AnotherPayloadDto",
        "bindings": {
          "jms": {
            "bindingVersion": "0.0.1"
          }
        }
      },
      "io.github.springwolf.examples.jms.dtos.ExamplePayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.jms.dtos.ExamplePayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.jms.dtos.ExamplePayloadDto",
        "title": "ExamplePayloadDto",
        "bindings": {
          "jms": {
            "bindingVersion": "0.0.1"
          }
        }
      }
    }
  },
  "operations": {
    "another-queue_receive_receiveAnotherPayload": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/another-queue"
      },
      "bindings": {
        "jms": { }
      },
      "messages": [
        {
          "$ref": "#/channels/another-queue/messages/io.github.springwolf.examples.jms.dtos.AnotherPayloadDto"
        }
      ]
    },
    "another-queue_send_sendMessage": {
      "action": "send",
      "channel": {
        "$ref": "#/channels/another-queue"
      },
      "title": "another-queue_send",
      "description": "Custom, optional description defined in the AsyncPublisher annotation",
      "bindings": {
        "jms": {
          "internal-field": "customValue",
          "nested": {
            "key": "nestedValue"
          }
        }
      },
      "messages": [
        {
          "$ref": "#/channels/another-queue/messages/io.github.springwolf.examples.jms.dtos.AnotherPayloadDto"
        }
      ]
    },
    "example-queue_receive_receiveExamplePayload": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/example-queue"
      },
      "bindings": {
        "jms": { }
      },
      "messages": [
        {
          "$ref": "#/channels/example-queue/messages/io.github.springwolf.examples.jms.dtos.ExamplePayloadDto"
        }
      ]
    }
  }
}